import debounce from 'lodash.debounce';

const ScrollSpy = {
  data() {
    return {
      sspyMixin_currentSection: '',
      sspyMixin_debouncedSpy: '',
    };
  },
  methods: {
    // init scroll spy for certain sections. needs refs of sections for determining offsetTop
    sspymixin_scrollSpy(availableSections, sectionsRefs, sectionMarginTop, debounceTimeout) {
      // debounce for better performance (scroll event fires not more than once every "debounceTimeout" ms)
      this.sspyMixin_debouncedSpy = debounce(() => {
        let sectionUpdate = '';
        Object.values(availableSections).forEach((section) => {
          if (sectionsRefs[section.ref]) {
            // set sspyMixin_currentSection to section id when user scrolls by
            if (window.pageYOffset >= sectionsRefs[section.ref].offsetTop - sectionMarginTop) {
              sectionUpdate = section.id;
            }
          }
        });
        this.sspyMixin_currentSection = sectionUpdate;
      }, debounceTimeout);

      window.addEventListener('scroll', this.sspyMixin_debouncedSpy, {
        // options for better performance
        capture: true,
        passive: true,
      });
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.sspyMixin_debouncedSpy, {
      capture: true,
    });
  },
};

export default ScrollSpy;
